import { render, staticRenderFns } from "./CanadaFrontOfPackConfiguration.vue?vue&type=template&id=56917b9e&scoped=true"
import script from "./CanadaFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanadaFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanadaFrontOfPackConfiguration.vue?vue&type=style&index=0&id=56917b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56917b9e",
  null
  
)

export default component.exports